import { MessageBlock } from '@deckee/deck-hand';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import * as React from 'react';
import {
  SHARING_MESSAGE__COPY_LINK,
  SHARING_MESSAGE__ERROR,
} from '../../../configurations/constants';
import { captureEvent } from '../../../services/event-capture';
import captureSpecificError from '../../../services/sentry';
import { getURLFromPath } from '../../helpers/share-helpers';
import { link } from '../../shared/vector-images';
import TextInput from '../../shared/_deprecated/components/TextInput/TextInput';
import Button from '../../shared/_deprecated/elements/Button/Button';
import styles from './SharingDialog.scss';

const cx = classNames.bind(styles);

const CopyLink = ({ path, onSuccess, submissionSuccess }) => {
  const textAreaRef = React.useRef(null);
  const [copyError, setCopyError] = React.useState();

  const copyToClipboard = async (_e) => {
    try {
      // try to use the navigator.clipboard api
      // fallback to input field copy which only works with readonly on the input field.
      if (navigator?.clipboard) {
        navigator.clipboard.writeText(getURLFromPath(path));
      } else {
        // this might not work with a disabled input field.
        textAreaRef.current.focus();
        textAreaRef.current.select();
        if (!document.execCommand('copy')) {
          throw new Error(
            'Copy command failed, no further information available',
          );
        }

        // unselect the text
        textAreaRef.current.focus();
      }

      await captureEvent({
        type: 'share: submitted',
        payload: {
          action: 'copied to clipboard',
        },
        sendToAmplitude: true,
      });

      onSuccess();
    } catch (error) {
      captureSpecificError(
        error,
        'containers/app-main-client/src/components/features/Sharing/CopyLink.jsx',
      );
      setCopyError(SHARING_MESSAGE__ERROR);
    }
  };

  return (
    <>
      {submissionSuccess ? (
        <MessageBlock
          className={cx('sharing-dialog__message-block')}
          type="info"
        >
          {SHARING_MESSAGE__COPY_LINK}
        </MessageBlock>
      ) : null}

      {!submissionSuccess && copyError ? (
        <MessageBlock
          className={cx('sharing-dialog__message-block')}
          type="error"
        >
          {copyError}
        </MessageBlock>
      ) : null}

      {!submissionSuccess ? (
        <>
          <TextInput
            className={cx('sharing-dialog__copy-link')}
            inputRef={textAreaRef}
            name="comment"
            label="Share link"
            fullWidth
            // readOnly
            value={getURLFromPath(path)}
          />
          <Button
            className={cx('sharing-dialog__copy-button')}
            type="secondary"
            size="medium"
            action={copyToClipboard}
            icon={link()}
          >
            Copy link
          </Button>
        </>
      ) : null}
    </>
  );
};

CopyLink.propTypes = {
  path: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  submissionSuccess: PropTypes.bool,
};

CopyLink.defaultProps = {
  submissionSuccess: false,
};

export default CopyLink;
